import { useIfUser } from '@if/mui'
import { useMemo } from 'react'
import AlertBanner from './AlertBanner'

const AlertBannerOnProduction = () => {
  const user = useIfUser()
  const isDev = user.roles.includes('Dev')
  const shouldShowProduction = useMemo<boolean>(() => {
    return isDev && import.meta.env.VITE_ENV === 'prod'
  }, [isDev])

  return <AlertBanner message="Production" show={shouldShowProduction} />
}

export default AlertBannerOnProduction
